import { StyledSearchBar, useDebouncedSearch } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { useRecoilState } from 'recoil';
import { searchGroupState } from '../../storage/groups';

function GroupFilters() {
  const { search, setSearch } = useDebouncedSearch(useRecoilState(searchGroupState));

  return (
    <StyledSearchBar
      name={'group-search'}
      value={search}
      onChange={(event) => setSearch(event)}
      clearable
      noMargin
    />
  );
}

export default memo(GroupFilters);
